module.exports = __webpack_public_path__ + "media/images/ui__warning--dark-fe61dfaf4a1192342722b973cef9b380.png";